import * as React from 'react';

import {CONSTANTS} from 'src/components/authentication/contants';
import {LinearLoader} from '@spaced-out/ui-design-system/lib/components/LinearLoader';

import css from './password-strength.css';

import type {PasswordStrengthProps} from 'src/types/authentication';


const PasswordStrength = (props: PasswordStrengthProps) => {
  const {className, strength} = props;

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  const getScoreClass = () => {
    switch (strength) {
      case 0:
        return css.noScore;
      case 1:
        return css.lowScore;
      case 2:
        return css.averageScore;
      case 3:
        return css.goodScore;
      case 4:
        return css.perfectScore;
    }
  };

  return (
    <div className={className}>
      <LinearLoader
        size="small"
        value={strength * 25}
        className={getScoreClass()}
      />
    </div>
  );
};

export default PasswordStrength;
